// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1b03c731","952":"f9bbf9ee"}[chunkId] + ".chunk.js";
};